import classNames from 'classnames';
import { Icon } from '~/components/Icon/Icon';

export type ExclamationProps = {
  className?: string;
};
export const Exclamation = ({ className }: ExclamationProps) => (
  <Icon
    className={classNames('exclamation', className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
    <rect x="7.38461" y="4.30762" width="1.23077" height="4.30769" fill="currentColor" />
    <rect x="7.38461" y="9.84619" width="1.23077" height="1.23077" fill="currentColor" />
  </Icon>
);
